import { createContext } from 'react';

export const RouterContext = createContext({
	auth: false,
	currentUser: null,
	onAuthentication() {},
});
